define('home/mixins/withEmailConfirmedModal',[
    'underscore',

    'core/advice',
    'core/UniqueModel',
    'core/utils/url/parseQueryString',

    'home/models/Session',
    'home/models/SettingsAccount',

    'home/views/EmailConfirmedModalContentView',
], function (
    _,

    advice,
    UniqueModel,
    parseQueryString,

    Session,
    SettingsAccount,

    EmailConfirmedModalContentView
) {
    'use strict';

    var EmailVerifiedModal = {

        showEmailVerifiedModal: function () {
            if (!this.shouldShowEmailVerifiedModal())
                return;

            var session = Session.get();
            session.loadPromise().then(_.bind(function () {
                if (session.isLoggedOut())
                    return;

                var settingsAccountModel = new UniqueModel(
                    SettingsAccount,
                    { id: session.user.id }
                );
                var modal = new EmailConfirmedModalContentView({
                    model: settingsAccountModel,
                });
                modal.showModal();
            }, this));
        },

        /**
         * Users are redirected to /home/channels/?email_verified=1 after verifying their email.
         * This method returns true if location.search contains email_verified=1.
         */
        shouldShowEmailVerifiedModal: function () {
            // TODO: use URI lib when we have it
            return Boolean(parseQueryString().email_verified);
        },

    };

    return function withEmailConfirmedModal() {
        advice.withAdvice.call(this);

        this.showEmailVerifiedModal = EmailVerifiedModal.showEmailVerifiedModal;
        this.shouldShowEmailVerifiedModal = EmailVerifiedModal.shouldShowEmailVerifiedModal;

        this.after('initialize', function () {
            this.showEmailVerifiedModal();
        });
    };
});


